import axios from 'axios'

export const downloadExcel= async (opts) => {
  console.log(opts)
  let res = await axios({
    method:opts.method,
    url:opts.url,
    data:opts.data,
    responseType: 'blob'
  })
  console.log(res);
  let resBlob = res.data
  var url = window.URL.createObjectURL(resBlob)
  var a = document.createElement('a');
  // a.download = '报表.xls'
  a.download = opts.fileName
  a.href = url;
  a.click();
  window.URL.revokeObjectURL(url)

  // try {
  //   let resText = await new Promise((resolve,reject)=>{
  //     let reader = new FileReader()
  //     reader.addEventListener('abort',reject)
  //     reader.addEventListener('error',reject)
  //     reader.addEventListener('loadend',()=>{
  //       console.log(reader.result)
  //       resolve(reader.result)
  //     })
  //     reader.readAsText(resBlob)
  //   })
  // }catch (error){
  
  // }

  return {res,resBlob}

}
// request拦截器
axios.interceptors.request.use(
  config => {
    // Do something before request is sent

    // console.log(config)
    let token = localStorage.getItem('token')
    if (token) {
      config.headers.common['authorization'] = token
    }
    return config
  },
  error => {
    // Do something with request error
    // console.log(error) // for debug
  }
)
export const downloadPic= async (opts) => {
  console.log(opts)
  let res = await axios({
    method:opts.method,
    url:opts.url,
    data:opts.data,
    responseType: 'blob'
  })
  console.log(res);
  let resBlob = res.data
  var url = window.URL.createObjectURL(resBlob)
  var a = document.createElement('a');
  // a.download = '报表.xls'
  a.download = opts.fileName
  a.href = url;
  a.click();
  window.URL.revokeObjectURL(url)

  // try {
  //   let resText = await new Promise((resolve,reject)=>{
  //     let reader = new FileReader()
  //     reader.addEventListener('abort',reject)
  //     reader.addEventListener('error',reject)
  //     reader.addEventListener('loadend',()=>{
  //       console.log(reader.result)
  //       resolve(reader.result)
  //     })
  //     reader.readAsText(resBlob)
  //   })
  // }catch (error){
  
  // }

  // return {res,resBlob}

}




// WEBPACK FOOTER //
// ./src/utils/downloadFetch.js